import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class DependenteService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'dependentes';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'pacientes';
  }

  procurarDependentePorFiltro(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro`, filtro);
  }

  procurarDependentesPorIdIncluindoInativos(entityId: number | string): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/porId/${entityId}/incluindoInativos`);
  }

  procurarDependentesInativos(idPaciente: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/inativos/${idPaciente}`);
  }

  removerDependente(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/remover`, value);
  }

  remover(entityId: number | string): Observable<any> {
    return this.http.put(`${this.getBaseUrlPrivate()}/remover/${entityId}`, null);
  }

  transformarDependenteEmTitular(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/transformarEmTitular`, value);
  }

  atualizar(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}`, value);
  }
}
